import PassChangeController from './passchange.controller';
import template from './passchange.html';
// import './passchange.scss';

export default {
	template,
	controller: PassChangeController,
	controllerAs: '$ctrl',
	path: '/passchange/:uid?',
	skipTokenCheck: true,
	showHeader: false,
};
